import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Profiles } from '../../models/profiles';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
const BASE_PATH = environment.basePath;

interface Permissions {
  id: string;
}

export interface CreateProfileRequest {
  profile: string;
  description: string;
  permissions: Array<Permissions>;
  forceTrue?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MasterClienteViewPermissionsCreateProfileService {
  constructor(private _$http: HttpClient) { }

  /**
   *  Recupera permissões na tela de Criar Perfil em modal
   */
  getPermissions(): Observable<any> {
    return this._$http
      .get<Array<Profiles>>(
        `${BASE_PATH}/bff/master/create-user/access-profiles/permissions/list`,
      )
  }

  /** Verifica se nome do Perfil já existe */
  checkPermissionName({ name }): Observable<any> {
    const payload = { "name": name };
    const url = `${BASE_PATH}/bff/master/create-user/access-profiles/create/verifyIfExists`;
    return this._$http.post(url, payload);
  }

  // checkPermissionExists(): Promise<any> {
  //   return this._$http
  //     .get(`${BASE_PATH}/bff/master/access-profile/profiles/create/exists`)
  //     .toPromise();
  // }

  /** Cria um novo perfil */
  createProfile(profile: CreateProfileRequest): Promise<any> {
    let url = `${BASE_PATH}/bff/master/create-user/access-profiles/create`;
    const { forceTrue } = profile;

    if (forceTrue) {
      url = `${BASE_PATH}/bff/master/create-user/access-profiles/create?insertDuplicated=true`;
    }

    return this._$http.post(url, profile).toPromise();
  }

  checkPermissions(profile: CreateProfileRequest): Promise<any> {
    return this._$http
      .post(
        `${BASE_PATH}/bff/master/create-user/access-profiles/verifyDuplicates`,
        profile,
      )
      .toPromise();
  }
}
